export default __webpack_public_path__ + "static/media/SIW500G_H250_W0.0af54161.webp";